import { BaseButton } from '@/src/components/buttons/BaseButton'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  ModalCloseButton,
  Text,
} from '@chakra-ui/react'
import { type FC, useRef } from 'react'

interface ISimpleConfirmDialog {
  isOpen: boolean
  onClose: () => void
  onAccept: () => void
  cancelLabel: string
  acceptLabel: string
  title: string
  bodyText: string
}

export const SimpleConfirmModal: FC<ISimpleConfirmDialog> = ({ isOpen, onClose, onAccept, cancelLabel, acceptLabel, bodyText, title }) => {
  const cancelRef = useRef()
  return (
    <AlertDialog
      isCentered
      isOpen={isOpen}
      // @ts-ignore
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent minWidth={'513px'}>
          <AlertDialogHeader fontSize='lg' fontWeight='bold' mb={'-16px'}>
            {title}
            <ModalCloseButton
              // @ts-ignore
              ref={cancelRef}
              _focus={{}}
            />
          </AlertDialogHeader>

          <AlertDialogBody>{bodyText}</AlertDialogBody>

          <AlertDialogFooter mt={'42px'} gap={'10px'}>
            <BaseButton onClick={onClose} variant='secondary'>
              {cancelLabel}
            </BaseButton>
            <BaseButton onClick={onAccept} variant='primary'>
              <Text mt={'1px'}>{acceptLabel}</Text>
            </BaseButton>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
